import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { DataEntity, ListDataEntity } from 'src/app/models/data-entities';
import {
  ConditionTarget,
  ConditionItem,
  LogicalOperator
} from './../../../../system/condition-builder/condition-builder.model';
import { Component, OnInit, Inject, forwardRef, ChangeDetectorRef, OnDestroy, Input } from '@angular/core';
import { DataEntityEditorBaseComponent } from '../../data-entity-editor-base/data-entity-editor-base.component';
import {
  FeeDataEntity,
  FeeDataEntityType
} from '../../../../../models/data-entities';
import {
  WorkflowService,
  WorkflowContextService,
  SystemService,
  SecurityService
} from '../../../../../services';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { PaymentAccount, Actions } from '../../../../../models';
import { forkJoin, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router'; // Code added by Sanchit on 07/28/2026

@Component({
    selector: 'wm-fee-data-entity-editor',
    templateUrl: './fee-data-entity-editor.component.html',
    styleUrls: ['./fee-data-entity-editor.component.css'],
    standalone: false
})
export class FeeDataEntityEditorComponent extends DataEntityEditorBaseComponent
  implements OnInit, OnDestroy {
  @Input() showManageFeeRecipientsLink = true;

  constructor(
    @Inject(forwardRef(() => WorkflowService))
    public _workflowSvc: WorkflowService,
    @Inject(forwardRef(() => WorkflowContextService))
    public context: WorkflowContextService,
    @Inject(forwardRef(() => SystemService)) private _systemSvc: SystemService,
    @Inject(forwardRef(() => SecurityService))
    private _securitySvc: SecurityService,
    private _fb: UntypedFormBuilder,
    private _ref: ChangeDetectorRef,
    private route: ActivatedRoute // Code added by Sanchit on 07/28/2026
  ) {
    super();
  }

  newLayout=false; // Code added by Sanchit on 07/28/2026
  departmentId: string = ''; // Code added by Sanchit on 07/28/2026

  FeeDataEntityType = FeeDataEntityType;
  feeEntity: FeeDataEntity;
  paymentAccounts: PaymentAccount[];
  canConfigureAccount: boolean;

  feeType: FeeDataEntityType;
  listDataEntitiesBefore: DataEntity[];
  listDeValues = [];
  listFeeOtherwise: number;
  listFeeAmounts: { [key: string]: number } = {};
  selectedPaymentAccount: PaymentAccount;
  useRecipientFromList: boolean;
  selectedClientFeeRecipientId: string;
  canManageFeeRecipients = false;
  clientSub: Subscription;
  // Start Code added by Sanchit on 07/28/2026
  private getDepartmentIdFromStoredUrl(): string {
    const storedUrl = localStorage.getItem('workflowBuilderReturnUrl');

    if (!storedUrl) {
      return '';
    }

    const segments = storedUrl.split('/');
    const departmentIndex = segments.indexOf('department');

    return departmentIndex !== -1
      ? segments[departmentIndex + 1] || ''
      : '';
  }
  // End Code added by Sanchit on 07/28/2026

  public changeFeeType(popover: NgbPopover) {
    const newType = parseFloat(this.feeType.toString());
    const oldType = parseFloat(this.feeEntity.type.toString());

    if (newType < oldType) {
      this.updateFormula([]);
      this.listFeeAmounts = {};
      this.listFeeOtherwise = null;
    }
    this.feeEntity.type = newType;

    popover.close();
  }

  get wf() {
    return this.workflow || this.context.workflow;
  }

  closeModal() {
    this.closeRequested.emit(true);
  }

  updateFormula(e) {
    (<FeeDataEntity>this.dataEntity).formulaCriteria = e;
    this.feeEntity.formulaCriteria = e;
    this.updated.emit(this.feeEntity);
  }

  ngOnInit() {
    this.newLayout=this.context.useNewLayout; // Code added by Sanchit on 07/28/2026
    this.departmentId = this.getDepartmentIdFromStoredUrl() || this.context.staffDepartmentId; // Code added by Sanchit on 07/28/2026

    this.clientSub = this.context.client$.subscribe(() => {
      this._ref.detectChanges();
    });

    this.feeEntity = this.dataEntity as FeeDataEntity;
    this.feeType = this.feeEntity.type || FeeDataEntityType.Simple;
    this.useRecipientFromList =
      !this.feeEntity.feeRecipient || this.feeEntity.feeRecipient === '';
    this.selectedClientFeeRecipientId = this.feeEntity.clientFeeRecipient
      ? this.feeEntity.clientFeeRecipient.id
      : null;

    if (!this.feeEntity.clientFeeRecipient) {
      this.feeEntity.clientFeeRecipient = null;
    }

    if (!this.feeEntity.formulaCriteria) {
      this.feeEntity.formulaCriteria = [];
    }

    if (this.showManageFeeRecipientsLink) {
      this._securitySvc
      .isLoginEntitled(Actions.MANAGE_FEE_RECIPIENTS)
      .subscribe(r => {
        this.canManageFeeRecipients = r;
      });
    }

    this.form.addControl(
      'canAdminEdit',
      this._fb.control(false, [Validators.nullValidator])
    );
    this.form.addControl(
      'type',
      this._fb.control(FeeDataEntityType.Simple, [Validators.nullValidator])
    );
    this.form.addControl(
      'listTemplateCode',
      this._fb.control(this.feeEntity.listTemplateCode, [
        Validators.nullValidator
      ])
    );
    this.form.addControl(
      'paymentAccount',
      this._fb.control(false, [Validators.nullValidator])
    );
    this.form.addControl(
      'feeRecipient',
      this._fb.control(false, [Validators.nullValidator])
    );
    this.form.addControl(
      'availableFeeRecipients',
      this._fb.control(false, [Validators.nullValidator])
    );
    this.form.addControl(
      'feeMinimum',
      this._fb.control(false, [Validators.nullValidator])
    );
    this.form.addControl(
      'feeMaximum',
      this._fb.control(false, [Validators.nullValidator])
    );

    if (this.targetClientId || this.context.client) {
      forkJoin(
        this._securitySvc
          .isLoginEntitled(Actions.PAYMENT_PROCESSOR_ACCOUNT_MANAGE)
          .pipe(
            map(e => {
              this.canConfigureAccount = e;
            })
          ),
        this._systemSvc.getPaymentAccounts(this.targetClientId || this.context.client.id).pipe(
          map(accounts => {
            this.paymentAccounts = this.globalTarget ? [] : accounts;
          })
        ),
        this._workflowSvc.getDataEntitiesBeforeMe(this.wf, this.activity, null, null, null, this.workflowVersionId).pipe(
          map(des => {
            this.listDataEntitiesBefore = des.filter(de => {
              return (
                de.dataEntityTypeCode ===
                WorkflowService.DATA_ENTITIES.ListData.code
              );
            });
          })
        )
      ).subscribe(() => {
        this.getListItems();
      });
    }

    if (this.feeEntity.type.toString() === FeeDataEntityType.List.toString()) {
      this.conditionsToList();
    }
  }

  /**
   * Translate a key/value list of fees into condition targets
   */
  private listToConditions() {
    const conditions: ConditionTarget[] = [];
    let order = 0;
    for (const key in this.listFeeAmounts) {
      if (this.listFeeAmounts[key]) {
        const target = new ConditionTarget({
          value: this.listFeeAmounts[key].toString(),
          group: new ConditionItem({
            isGroup: true,
            logicalOperator: LogicalOperator.And,
            conditions: [
              new ConditionItem({
                field: this.feeEntity.listTemplateCode,
                formulaOperator: '~',
                val: key
              })
            ]
          }),
          order
        });

        conditions.push(target);

        order += 1;
      }
    }

    if (this.listFeeOtherwise) {
      conditions.push(
        new ConditionTarget({
          isOtherwise: true,
          value: this.listFeeOtherwise.toString(),
          group: new ConditionItem({
            isGroup: true,
            logicalOperator: LogicalOperator.And
          }),
          order: 0
        })
      );
    }

    return conditions;
  }

  ngOnDestroy() {
    if (this.clientSub) {
      this.clientSub.unsubscribe();
      this.clientSub = null;
    }
  }

  /**
   * Translate condition targets into a key/value list of fees
   */
  private conditionsToList() {
    for (const condition of this.feeEntity.formulaCriteria) {
      if (condition.isOtherwise) {
        this.listFeeOtherwise = parseFloat(condition.value);
      } else {
        const key = condition.group.conditions[0].val.toString();
        const value = parseFloat(condition.value);

        this.listFeeAmounts[key] = value;
      }
    }
  }

  public listFeesChange() {
    this.updateFormula(this.listToConditions());
  }

  getListItems() {
    this.feeEntity.listTemplateCode = this.form.controls[
      'listTemplateCode'
    ].value;
    if (
      this.feeEntity.type === FeeDataEntityType.List &&
      this.feeEntity.listTemplateCode
    ) {

      // we've built available list data entities at this point, so if we have a selected 
      // listTemplateCode for this fee, then its definition can be found in the those available list DE
      const ldeDef = this.listDataEntitiesBefore.find(lde => lde.templateCode == this.feeEntity.listTemplateCode);

      if (ldeDef) {
        this.listDeValues = (ldeDef as ListDataEntity).availableListItems;
      }
    }
  }

  public isType(value: string | number, type: FeeDataEntityType) {
    return value.toString() === type.toString();
  }

  // Use => in order to force `this` into being the FeeDataEntityEditorComponent
  getThenLabel = (clause: ConditionTarget): string => {
    if (clause) {
      return clause.value;
    } else {
      return '(unset)';
    }
  };

  isFeeAccountConfigured() {
    if (
      this.feeEntity &&
      this.paymentAccounts &&
      this.feeEntity.paymentAccountId
    ) {
      const acct = this.paymentAccounts.find(
        pa => pa.id === this.feeEntity.paymentAccountId
      );

      return !acct ? false : acct.isConfigured;
    }

    return false;
  }

  setRecipientType(useRecipientFromList: boolean) {
    this.useRecipientFromList = useRecipientFromList;

    if (useRecipientFromList) {
      this.feeEntity.feeRecipient = null;
    }
    if (!useRecipientFromList) {
      this.feeEntity.clientFeeRecipient = null;
      this.selectedClientFeeRecipientId = null;
    }
  }

  setClientFeeRecipient() {
    const selectedClientFeeRecipient = this.feeEntity.availableFeeRecipients.find(
      afr => afr.id === this.selectedClientFeeRecipientId
    );

    this.feeEntity.clientFeeRecipient = JSON.parse(
      JSON.stringify(selectedClientFeeRecipient)
    );
  }
}
